import { useEffect } from 'react';

/**
 * Round 154b (D4) - puts the learner's language and direction on the <html> element, and gives them back when the learner tree unmounts.
 *
 * LearnerShell's wrapper element already carries lang/dir for the page content, but <html> kept lang="en" dir="ltr" in the Arabic UI: a screen
 * reader picks its voice from <html lang>, and the browser's own controls (scrollbars, form controls, find) follow <html dir>. The admin tree is a
 * SIBLING of the learner tree and is always English / LTR, so the cleanup restores 'en' / 'ltr' the moment the learner tree leaves the page.
 */
export function useDocumentLanguage(language: string, dir: 'ltr' | 'rtl'): void {
  useEffect(() => {
    const el = document.documentElement;
    el.setAttribute('lang', language);
    el.setAttribute('dir', dir);
    return () => { el.setAttribute('lang', 'en'); el.setAttribute('dir', 'ltr'); };
  }, [language, dir]);
}
